export default "__VITE_ASSET__C57NVK$H__"